import React from 'react';
import LinkComponent from 'components/LinkComponent';

export const LinkModalComponent = (canvasSVGObject) => {
    return (
        <LinkComponent canvasSVGObject={canvasSVGObject} />
    )
};
